import { PeriodRangeOptionEnum } from "Features/pages/costCenters/costCenterDetails/costCenterPeriodOption.interface"
import moment from "moment"
import { useSelector } from "react-redux"
import { RootState } from "Shared/store/rootState.interface"
import { sumBy } from "Shared/utils/helpers"

export const useOverviewData = () => useSelector(({ analytics }: RootState) => analytics.overviewData)

export const useCardOverviewData = () => useSelector(({ analytics: { cards } }: RootState) => cards.overviewData)

export const useCostCenterBudgetData = () => useSelector(({ analytics }: RootState) => analytics.costCenterBudgetData)

export const useCostCenterOverLast12MonthsData = () => useSelector(({ analytics }: RootState) => analytics.expensesPerCostCenterOverLast12MonthsData)

export const useCostCenterOverLast12MonthsFilter = () => useSelector(({ analytics }: RootState) => analytics.expensesPerCostCenterOverLast12MonthsFilter)

export const useEmployeeData = () => {
    const employeeData = useSelector(({ analytics }: RootState) => analytics.expensesPerEmployee).filter((dataSet: any) => dataSet.value > 0)
    return {
        employeeData: employeeData || [],
        maxEmployeeValue: employeeData ? Math.max(...employeeData.map((dataSet: any) => dataSet.value)) : 0,
        totalSumEmployees: employeeData ? sumBy(employeeData, "value") : 0,
    }
}

export const useCostCenterExpenseData = () => useSelector(({ analytics }: RootState) => analytics.costCenterExpenseData)

export const useCostCenterExpenseDataPie = () => useSelector(({ analytics }: RootState) => analytics.costCenterExpenseDataPie)

export const useExpensesPerDepartmentDataPie = () => useSelector(({ analytics }: RootState) => analytics.expensesPerDepartmentDataPie)

export const useExpensesPerDepartmentIntervalPie = () => useSelector(({ analytics }: RootState) => analytics.expensesPerDepartmentIntervalPie)

export const useEmployeeInterval = () => useSelector(({ analytics }: RootState) => analytics.employeeInterval)

export const useCostCenterInterval = () => useSelector(({ analytics }: RootState) => analytics.costCenterInterval)

export const useCostCenterIntervalPie = () => useSelector(({ analytics }: RootState) => analytics.costCenterIntervalPie)

export const useCostCenterBudgetUsageBarGraphOptions = (isOnMobile = false) => {
    const graphOptions = useSelector(({ analytics }: RootState) => analytics.costCenterBudgetUsageBarGraphOptions)
    const DEFAULT_MOBILE_PERIODS = 6
    const DEFAULT_DESKTOP_PERIODS = 12
    const defaultPeriods = isOnMobile ? DEFAULT_MOBILE_PERIODS : DEFAULT_DESKTOP_PERIODS
    graphOptions.periodRangeOption = graphOptions.startDate
        ? graphOptions.periodRangeOption
        : isOnMobile
        ? PeriodRangeOptionEnum.LAST_6_PERIODS
        : PeriodRangeOptionEnum.LAST_12_PERIODS
    graphOptions.startDate = graphOptions.startDate || moment().startOf("month").subtract(defaultPeriods, "months").utc(true).toISOString()
    graphOptions.endDate = graphOptions.endDate || moment().endOf("month").utc(true).toISOString()
    return graphOptions
}
